<template>
  <div :class="{'nav-open': $sidebar.showSidebar}" class="app">
    <notifications></notifications>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {}
</script>
<style lang="scss">
  body,html{
    height:100;
  }
  .bg-yellow{
    background-color:#FFFF8D !important;
  }
  .bg-green{
    background-color:#CCFF90 !important;
  }
  .bg-orange{
    background-color:#FFD180 !important;
  }
  .bg-red{
    background-color:#FF8A80 !important;
  }
  .bg-grey{
    background-color:#9E9E9E !important;
  }
  .bg-black{
    background-color:#000000 !important;
    color: #FFFFFF !important;
  }
  .vue-notifyjs.notifications{
    .list-move {
      transition: transform 0.3s, opacity 0.4s;
    }
    .list-item {
      display: inline-block;
      margin-right: 10px;

    }
    .list-enter-active {
      transition: transform 0.2s ease-in, opacity 0.4s ease-in;
    }
    .list-leave-active {
      transition: transform 1s ease-out, opacity 0.4s ease-out;
    }

    .list-enter {
      opacity: 0;
      transform: scale(1.1);

    }
    .list-leave-to {
      opacity: 0;
      transform: scale(1.2, 0.7);
    }
  }
  .fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .pointer{
    cursor: pointer;
    user-select:none;
  }
  
</style>
